<template>
  <div class="qr-card" v-if="url">
    <img class="img" :src="url" alt />
    <p class="text" v-if="deviceType=='weixin'">长按识别图中二维码</p>
    <p class="text" v-else>扫一扫图中二维码</p>
    <p class="text phone" v-if="deviceType=='pc'">4008806283</p>
    <p class="text go-top" v-if="deviceType=='pc'&&show" @click="scrollTop">回顶部</p>
  </div>
</template>
<script>
import XHR from '../api'

export default {
  name: 'QRCard',
  props: [],
  data: () => ({
    url: '',
    show: false
  }),
  components: {

  },
  created () {
  },
  mounted () {
    this.getHandWork()
    window.onscroll = (e) => {
      const top = document.documentElement.scrollTop || document.body.scrollTop
      const screenTop = document.body.clientHeight
      if (top > screenTop) {
        this.show = true
      } else {
        this.show = false
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    getHandWork () {
      XHR.getHandWork({
        type: 40,
        hid: 4126
      }).then(res => {
        const { status, data } = res.data
        if (!status) {
          this.url = data[0].info1
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 回到顶部
    scrollTop () {
      // 清空上一次的定时器
      clearInterval(this.timer)
      const toTop = document.querySelector('.logo').offsetHeight
      this.timer = setInterval(() => {
        const top = document.documentElement.scrollTop || document.body.scrollTop
        const speed = Math.ceil((top - toTop) / 5)
        document.body.scrollTop = document.documentElement.scrollTop = top - speed - 30
        if (top <= toTop) {
          clearInterval(this.timer)
        }
      }, 20)
    }
  }
}
</script>
<style lang="less" scoped>
.qr-card {
  position: relative;
  display: flex;
  align-items: center;
  padding: 16px 0;
  .img {
    width: 60px;
    height: 60px;
    margin-left: 20px;
  }
  .text {
    font-size: 14px;
    color: #000000;
    margin-left: 12px;
    display: flex;
    justify-content: center;
    align-items: center;

    &.phone::before {
      content: "\e7f5";
      font-size: 20px;
      display: inline-block;
      font-family: "iconfont";
      margin-right: 5px;
    }
    &.go-top::before {
      content: "\e7f0";
      display: inline-block;
      font-family: "iconfont";
      margin-right: 10px;
    }
  }
}
@media screen and (min-width: 376px) {
  .qr-card {
    position: fixed;
    top: 580px;
    right: 200px;
    z-index: 1000;
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 120px;
    background-image: linear-gradient(270deg, #3d83ff 0%, #3a48db 100%);
    box-shadow: 0 4px 8px 0 rgba(61, 114, 245, 0.4);
    padding: 0;
    .img {
      width: 100px;
      height: 100px;
      margin: 10px auto;
    }
    .text {
      font-size: 12px;
      color: #ffffff;
      line-height: 18px;
      margin-left: 0;
      padding: 10px 0;
      &:first-of-type {
        padding-top: 0;
      }
      &.phone {
        width: 100%;
        border-top: 1px solid rgba(255, 255, 255, 0.2);
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      }
    }
  }
}
</style>
